import { MainInner, MainSection } from "@/styles/global";
import { Body, H3 } from "@/styles/typography";
import styled from "styled-components";

type StyleProps = {
  $backgroundType: "card" | "fill";
};

const Section = styled.div<StyleProps>`
  background: ${({ $backgroundType, theme }) =>
    $backgroundType === "fill" ? "rgb(254, 251, 247)" : "none"};
  width: 100%;
  padding: 48px 0;
  position: relative;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 88px 0;
  }
`;

const Inner = styled(MainInner)`
  flex-direction: column;
`;

const Card = styled.div<StyleProps>`
  ${({ $backgroundType, theme }) =>
    $backgroundType === "card" &&
    `
    background: rgb(254, 251, 247);
    padding: 16px;
    border-radius: 21px;

    @media screen and (min-width: ${theme.breakpoints.lg}) {
      padding: 48px 40px;
    }
  `};
`;

const Wrapper = styled.a`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0px;
  width: 100%;
  text-decoration: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black}80;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 24px 8px;
    cursor: pointer;
  }
`;

const Title = styled(H3)``;

const Text = styled(Body)`
  opacity: 0.5;
`;

const S = {
  Section,
  Inner,
  Card,
  Wrapper,
  Title,
  Text,
};

export default S;
